export function getMbData() {
	var obj = {
		headData: [{
				title: "顺序",
				prop: "sunxu",
				custom: true,
			},
			{
				title: "审核员",
				prop: "name",
				custom: true,
				width: "200px"
			},
			{
				title: "审核方式",
				prop: "shenghefnags",
				custom: true,
				width: "200px"
			},
			{
				title: "相关用户",
				prop: "userNames",
				width: 160,
				align: "left"
			},
			{
				title: "审核规则",
				prop: "passType",
				width: "400px",
				custom: true,
			},
			{
				title: "操作",
				prop: "cz",
				width: "200px",
				fixed: "right",
				custom: true,
			},
		],
		userHeadData: [{
			title: "姓名",
			prop: "nickName",
			width: "80"
		},
		{
			title: "用户名",
			prop: "username",
			width: "80"
		},
		{
			title: "手机",
			prop: "phoneNumber",
			width: "100"
		},
	],
	userHeadtitle: [{
			label: "基础信息"
		},
		{
			label: "用户角色"
		},
	],
	userTableData: [],
	pagination: {
		pageNum: 1,
		pageSize: 50,
		total: 0,
		paginationkey: 0
	},
	}
	return obj
}
